/**
 * @generated SignedSource<<72f05e4de43ec87c3b8671dafe8f2202>>
 * @relayHash d44b539e2e66d2ab43fb471424bd194c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8996b0d54010b1874ccc4a12411cb237dd073d6348d3d6a6e4e1e90c659257a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import withNewRankField_provider from '@atlassian/jira-relay-provider/src/fun-1500-swap-business-inline-create-rank-fetcher.relayprovider';
import isSavedViewsColumnOrderSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-order-setting.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d8996b0d54010b1874ccc4a12411cb237dd073d6348d3d6a6e4e1e90c659257a",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnordersettingrelayprovider": isSavedViewsColumnOrderSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider": withNewRankField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider
    }
  }
};

export default node;
